module.exports = __webpack_public_path__ + "static/img/homebgv2.3c36198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homebgv2.jpg
// module id = M2Zy
// module chunks = 19